import PropTypes from "prop-types";
import React, { useState } from "react";

const GenreWeekdayCard = ({ genreWeekday }) => {
  const [open, setOpen] = useState(true);
  const max = Math.max(1, ...genreWeekday.days.map((d) => d.avg));
  return (
    <div className="d2-card">
      <div className="d2-card-header">
        <div>
          <h2 className="d2-card-title">{`${genreWeekday.genreLabel} by day of week`}</h2>
          <p className="hd-audience-sub">{genreWeekday.scopeLabel}</p>
        </div>
        <button type="button" className="hd-link-btn" onClick={() => setOpen((v) => !v)}>{open ? "Hide chart" : "Show chart"}</button>
      </div>
      {open && (
        <div className="hd-chart">
          {genreWeekday.days.map((d) => {
            const hasHistory = d.count > 0;
            return (
              <div key={d.label} className={`hd-chart-col${hasHistory ? "" : " hd-chart-col-empty"}`}>
                <div className="hd-chart-val">{hasHistory ? d.avg : "—"}</div>
                <div className={`hd-bar${d.held ? " hd-bar-held" : ""}`} style={{ height: `${hasHistory ? Math.round((d.avg / max) * 140) : 0}px` }} />
                <div className="hd-chart-label">{d.label}</div>
                <div className="hd-chart-count">{hasHistory ? `${d.count} ${d.count === 1 ? "show" : "shows"}` : "no history"}</div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

GenreWeekdayCard.propTypes = { genreWeekday: PropTypes.object.isRequired };
export default GenreWeekdayCard;
